import moment from 'moment'

export function formatDate (dateString) {
  const now = moment()
  const momentObj = moment(dateString)

  momentObj.locale('sv')

  return momentObj.calendar(now, {
    sameDay: 'HH:mm [idag]',
    nextDay: 'HH:mm [imorgon]',
    nextWeek: 'HH:mm dddd',
    lastDay: 'HH:mm [igår]',
    lastWeek: 'HH:mm, DD/MM',
    sameElse: 'HH:mm, DD/MM'
  })
}

export function formatFixedPrice (estimate) {
  return estimate.finalPrice ? `${estimate.finalPrice} kr` : ''
}

export function formatPickupTimestamp (dateStr) {
  const date = moment(dateStr, 'YYYY-MM-DD HH:mm')
  return date.format('YYYY-MM-DDTHH:mm:ssZ')
}

export function formatAddress (address) {
  return `${address.streetName}${address.streetNumber ? ' ' + address.streetNumber : ''}${address.entrance ? ' ' + address.entrance : ''}${address.city ? ', ' + address.city : ''}`
}

export function newlineToBr (text) {
  return text.replace(/\r\n/g, '<br />')
}

const bookingStatuses = {
  100: 'Förberedd', // Prepared
  110: 'Ny', // New
  120: 'Bokad', // Confirmed [status: Bokad]
  121: 'Pågående', // ConfirmedWithChanges [status: Pågående] (means reassigned to different car)
  130: 'Avvisad', // Rejected
  180: 'Utgången', // Expired (For prepared orders)
  190: 'Misslyckad', // Failed (For prepared orders)
  210: 'Avbeställning (pågående)', // CancellationRequested [status: Avbeställning (pågående)]
  220: 'Avbeställd', // Cancelled [status: Avbeställd]
  230: 'Avbeställd (konsekvenser)', // CancellationAcceptedWithConsequence [status:Avbeställd (med konsekvenser)]
  240: 'Avbeställning nekad', // CancellationRejected [status: Avbeställning nekad]
  310: 'Bil på väg', // Dispatched [status: Bil på väg] (includes ETA field)
  320: 'På adress', // AtPickup [status: På adress]
  410: 'Kund i bil', // EnRoute [status: Kund i bil]
  510: 'Utförd', // Done [status: Utförd]
  610: 'Avslutad', // Terminated [status: Avslutad]
  620: 'Avslutad/No show', // TerminatedNoShow [status: Avslutad/No show]
  630: 'Anullerad' // Annulled
}
export function getStatus (code) {
  return bookingStatuses[code] || code
}

export function formatStreetAddress(location) {
  const sa = []
  if (location && location.address) {
    const a = location.address
    if (a && a.streetName) sa.push(a.streetName)
    if (a && a.streetNumber) {
      let sn = a.streetNumber
      if (a.entrance) sn += a.entrance
      sa.push(sn)
    }
  }
  return sa.join(' ')
}

export function formatAddressParts(location) {
  const title = []
  const subtitle = []
  const sa = formatStreetAddress(location)
  
  if (location && location.locationType && location.locationType !== 'STREET' && ((location.address && location.address.poiName) || location.name)) {
    title.push(location.name ? location.name : (location.address && location.address.poiName) ? location.address.poiName : '' )
    if (sa) {
      subtitle.push(sa)
    }
  }
  else {
    if (sa) {
      title.push(sa)
    }
  }
  if (location && location.address && location.address.city) {
    subtitle.push(location.address.city)
  }
  if (location && location.address && location.address.municipality && !subtitle.includes(location.address.municipality)) {
    subtitle.push(location.address.municipality)
  }
  return {
    title: title.join(' '),
    subtitle: subtitle.join(', ')
  }
}

export function formatLocationTitle(location) {
  const title = []

  if (location && location.locationType && location.locationType !== 'STREET' && ((location.address && location.address.poiName) || location.name)) {
    title.push((location.address && location.address.poiName) ? location.address.poiName : location.name)
  }
  else {
    const sa = formatStreetAddress(location)
    if (sa) {
      title.push(sa)
    }
  }
  if (location && location.address && location.address.city) title.push(location.address.city)
  return title.join(', ')
}



// WEBPACK FOOTER //
// ./src/utils/format.js